import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    control: {
      selected: 'bg-brand-4'
    },
    label: {
      default: 'c-black',
      shared: 'body-4'
    },
    wrapper: 'gap-x-3'
  }
} satisfies RecursivePartial<VfConfig['switch']>
